import Swal from 'sweetalert2/dist/sweetalert2.js'

window['Swal'] = Swal;

const random = () => {
    for (var e = "", n = "0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ", a = 32; 0 < a; --a)
        e += n[Math.round(Math.random() * (n.length - 1))];
    return e;
};
const lead_id = random();
if (!$(`[name="lead_id"]`).val()) {
    $(`[name="lead_id"]`).val(lead_id);
}


// $("#phone").on('input', e => {
//     var val = String(e.target.value);
//     if( !val.match(/\+48/) ){
//         var clean = String(e.target.value).replace(/^\+48*/,'');
//         e.target.value = `+48${clean}`;
//     }
// });

$('form').each((i, form) => {

  $(form).validate({
      ignore: ":hidden:not(:checkbox)",
      focusInvalid: false,
		rules: {
			email: {
				required: true,
				email: true,
			},
			name: {
				required: true,
			},
			surname: {
				required: true,
			},
			phone: {
				required: true,
				phone: true,
			},
			city: {
				required: true,
			},
			//   nip:{
			//       required: true,
			//       nip: true
			//   },
			agree1: {
				required: true,
			},
			agree2: {
				required: true,
			},
			agree3: {
				required: true,
			},
			agree4: {
				required: false,
			},
		},
		messages: {
			email: {
				required: 'Podaj prawidłowy adres "E-mail"',
				email: 'Podaj poprawny adres "E-mail"',
			},
			name: {
				required: `Podaj "Imię"`,
				fullName: `Podaj "imię i nazwisko"`,
			},
			surname: {
				required: `Podaj "Nazwisko"`,
				fullName: `Podaj "Nazwisko"`,
			},
			phone: {
				required: `Podaj "Numer telefonu"`,
				phone: `Podaj poprawny "Numer telefonu"`,
			},
			city: {
				required: `Podaj "Nazwę miasta"`,
			},
			nip: {
				required: `Podaj "Numer NIP"`,
				nip: `Podaj poprawny "Numer NIP"`,
			},
			agree1: {
				required: `Zaznacz wymagane zgody`,
			},
			agree2: {
				required: `Zaznacz wymagane zgody`,
			},
			agree3: {
				required: `Zaznacz wymagane zgody`,
			},
			// agree_email:{
			//     required: `Zaznacz wymagane zgody`
			// },
		},
		invalidHandler: function (event, validator) {
			// 'this' refers to the form
			// console.log(event, validator);
			var errors = validator.numberOfInvalids();
			var errorList = validator.errorList;
			// var message = "Wprowadź proszę poprawne dane<br><ul>";
			var message = "<ul>";
			// + this.numberOfInvalids()

			for (var i = 0; i < errorList.length; i++) {
				var field = errorList[i];
				message += "<li>" + field.message + "</li>";
			}
			message += "</ul>";
			// Swal.fire({
			// 	title: "Wprowadź poprawne dane",
			// 	// text: message,
			// 	html: message,
			// 	type: "error",
			// 	buttonsStyling: false,
			// 	confirmButtonClass: "btn primary",
			// });
		},
		submitHandler: function (form) {
			$(".showbox").show();
			const action = $(form).attr("action");
			const data = $(form).serialize();

			$("[type=submit]").attr("disabled", "disabled");

			$.post(action, data)
				.then((data) => {
					// console.log(data);
					// $("#formContent").hide();
					// $("#thxContent").show();

					$(".showbox").hide();

					$(form).get(0).reset();

					window.location.href = `thx.php?lead_id=${lead_id}`;

					gtag("event", lead_id, {
						event_category: "formularz",
						event_label: "wyslij",
						event_callback: function () {
							window.location.replace(`thx.php?lead_id=${lead_id}`);
						},
					});
				})
				.always(() => {
					$("[type=submit]").removeAttr("disabled");
				})
				.fail((err) => {
					console.error(err);

					Swal.fire({
						// text: message,
						html: "Coś poszło nie tak",
						type: "error",
						buttonsStyling: false,
						confirmButtonClass: "btn primary",
					});
				});
		},
		highlight: function (element) {
			$(element).addClass("error");
			// $(element).next('span').addClass('error-checkbox');
		},
		unhighlight: function (element) {
			$(element).removeClass("error");
			// $(element).next('span').removeClass('error-checkbox');
		},
		errorPlacement: function (error, element) {
			// var w = element.closest('.input-wrapper, .form-check') || element.parent();
			// error.appendTo(w);
		},
  });
})
